// extracted by mini-css-extract-plugin
module.exports = {"socialList":"info-blocks_socialList__oEjmI"};